import styled from 'styled-components';
import { PAGE_BOTTOM_PADDING } from '../../../config/constants';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 16px;
`;
export const HeaderMain = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: 4px;
`;
export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 4px;
`;
export const HeaderActions = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
export const HeaderSecondaryInfo = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 2px;
`;
export const IconActions = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2px;
`;

// Note: a little margin right for the dashboard is added
// to give space to allow (+ button) to show in dashboard page without overlapping the scrollbar
export const ContentWrapper = styled.div<{ $isEmpty: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding-bottom: ${({ $isEmpty }) =>
    $isEmpty ? '140px' : PAGE_BOTTOM_PADDING};
  margin-right: 8px;
  @media print {
    margin-right: 0;
    padding-bottom: 0;
  }
`;
